export enum EmergencyOptionId {
    OneMonth = 'oneMonth',
    ThreeMonth = 'threeMonth',
    SixMonth = 'sixMonth',
    MoreSixMonth = 'moreSixMonth',
}

export default EmergencyOptionId;
